import React from "react";
import { Pressable, ScrollView, StyleSheet, Text, View } from "react-native";
import { MaterialIcons } from "@expo/vector-icons";

import SectionTitle from "./SectionTitle";

import { type TransportationOption } from "@/schemas/events/EventDirection";
import { themes } from "@/Components/Styling/themeConfigs";

type Props = {
  options: TransportationOption[];
};

export const EventDirections = ({ options }: Props): React.JSX.Element => {
  const doNothing = (): void => {};

  const currentTheme = themes.morning;

  const iconSize = currentTheme.icon.size.web.medium;
  const iconColor = currentTheme.icon.color;
  const textSize = currentTheme.typography.h3.size.web;
  const textColor = currentTheme.typography.h3.color;

  const styles = StyleSheet.create({
    container: {
      // paddingVertical: 16,
    },
    card: {
      backgroundColor: "#FFFFFF",
      borderRadius: 12,
      padding: 16,
      marginRight: 12,
      width: 300,
    },
    cardHeader: {
      flexDirection: "row",
      alignItems: "center",
      marginBottom: 12,
    },
    iconContainer: {
      borderRadius: 20,
      justifyContent: "center",
      alignItems: "center",
      marginRight: 12,
    },
    titleContainer: {
      flex: 1,
    },
    title: {
      fontSize: textSize,
      fontWeight: "600",
      color: textColor,
      marginBottom: 2,
    },
    duration: {
      fontSize: textSize,
      color: textColor,
    },
    instructions: {
      gap: 8,
    },
    instructionItem: {
      flexDirection: "row",
      alignItems: "flex-start",
    },
    bullet: {
      fontSize: textSize,
      color: textColor,
      marginRight: 8,
      marginTop: 2,
    },
    text: {
      flex: 1,
      fontSize: textSize,
      color: textColor,
      lineHeight: 20,
    },
  });

  return (
    <View style={styles.container}>
      <SectionTitle title="Directions" />
      <ScrollView horizontal showsHorizontalScrollIndicator={false}>
        {options.map((option, index) => (
          <Pressable
            key={index}
            style={[styles.card]}
            onPress={() => doNothing()}
          >
            {/* Card Header */}
            <View style={styles.cardHeader}>
              <View style={styles.iconContainer}>
                <MaterialIcons
                  name={option.icon}
                  size={iconSize}
                  color={iconColor}
                />
              </View>
              <View style={styles.titleContainer}>
                <Text style={styles.title}>{option.title}</Text>
                <Text style={styles.duration}>{option.duration}</Text>
              </View>
            </View>

            {/* Instructions */}
            <View style={styles.instructions}>
              {option.instructions.map((instruction, idx) => (
                <View key={idx} style={styles.instructionItem}>
                  <Text style={styles.bullet}>•</Text>
                  <Text style={styles.text}>{instruction}</Text>
                </View>
              ))}
            </View>
          </Pressable>
        ))}
      </ScrollView>
    </View>
  );
};
